export const displayCHF = number =>
  new Intl.NumberFormat("de-CH", {style: "currency", currency: "CHF"}).format(
    number
  )



// WEBPACK FOOTER //
// ./src/helpers/number.js